// @flow

import React, { useContext } from "react";
import classnames from "classnames";
import { Header, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

import Styles from "modules/ShortOfferForm/components/ShortOfferForm.module.scss";
import ShortFormSharedContext from "../../../../misc/context";

import { Button } from "../../../shared/CommonComponents";
import { read } from "modules/ShortForm/misc/utilities";

import DashboardRoute from "modules/Dashboard/misc/Routes";

import { scrollToPosition } from "Commons/Utilities/scrollTo";

const Confirmation = () => {
  const {
    inheritedStyles,
    configurationData: {
      translations: { confirmation },
    },
  } = useContext(ShortFormSharedContext);
  const {
    formRow,
    confirmationStep,
    confirmationTitle,
    confirmationSubTitle,
    confirmationParagraph,
    formStepButton,
  } = inheritedStyles;

  return (
    <div className={confirmationStep}>
      <div className={classnames(formRow)}>
        <Header as="h5" className={Styles.title}>
          <Icon name={"check"} className={classnames(Styles["lite-header-icon"], "theme-color-primary")} />
          <Header.Content className={confirmationTitle}>{read(confirmation.title)}</Header.Content>
        </Header>
        <p className={confirmationSubTitle}>{read(confirmation.subTitle)}</p>
        <p className={confirmationParagraph}>{read(confirmation.paragraph)}</p>
      </div>
      <div className={classnames(formRow)}>
        <Link to={DashboardRoute} onClick={() => scrollToPosition(0, 0)}>
          <Button className={formStepButton}>
            {read(confirmation.toDashboard)}
            <Icon name="arrow right" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Confirmation;
